module.exports = __webpack_public_path__ + "static/media/CC-COL5_1QZCx0I6v6mzOJpWDBVpLclgcEtv4I4Mi.e87e96fc.bin";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thumbs/CC-COL5_1QZCx0I6v6mzOJpWDBVpLclgcEtv4I4Mi
// module id = 779
// module chunks = 0